function formatCount(count) {
  const n = Number(count) || 0;
  return n.toLocaleString('en-US');
}

export function formatFileWordCount(count) {
  const n = Number(count) || 0;
  if (n <= 0) return '';
  return `${formatCount(n)} words`;
}

export function batchWordCount(batch) {
  return (batch?.documents || []).reduce(
    (sum, doc) => sum + (Number(doc.word_count) || 0),
    0,
  );
}

// Doc list description is the file name (the label) plus this word count.
// A digest field, including a guessed series note, is not the description.
export function docListDetail(batch, emptyLine) {
  const words = formatFileWordCount(batchWordCount(batch));
  if (words) return words;
  if (batch?.approved) return 'Digest approved.';
  return emptyLine;
}
